import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { QuotesNotesDto } from "../../../../core/models/qoutes/quotesNotesDto";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ScrollPanelModule } from "primeng/scrollpanel";

@Component({
  selector: "jni-invoice-preview-billing-comment",
  templateUrl: "./invoice-preview-billing-comment.component.html",
  imports: [
    CommonModule,
    ScrollPanelModule,
    HidedynamicsdatePipe,
    ModalStackerComponent,
  ],
  styleUrls: ["./invoice-preview-billing-comment.component.scss"],
})
export class InvoicePreviewBillingCommentComponent {
  @Input() orderBillingHeading = "";
  @Input() orderNotesGridListing: QuotesNotesDto[] = [];
  @Input() orderNumber = "";
  @Input() allComments = "All Billing Notes";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() orderNotesDisplayModalEvent = new EventEmitter<boolean>();

  orderNotesDisplayModal = false;

  redirectToAllBilling() {
    if (this.orderNumber) {
      this.orderNotesDisplayModalEvent.emit(true);
    }
  }

  closeModalForOrderNotes() {
    this.orderNotesDisplayModal = false;
  }

  addScollHiddenClass() {
    this.scrollHiddenStatus.emit();
  }
}
